/**
 * 낭만작명 채점 규칙(13개) 색상 팔레트.
 * Figma "그래프 바 색상" 디자인 기준 (낭만작명_UI / node 609:9064).
 *
 * 각 항목:
 *   - color: 그래프 바 fill / 텍스트 색 (Figma solid)
 *   - bg: 옅은 배경 (라벨 chip 등에 사용, alpha 0.07)
 *
 * 사용 예:
 *   import { getNamingRulePalette } from '@/utils/namingRulePalette';
 *   const { color, bg } = getNamingRulePalette('용신');
 */

const ALPHA = 0.07;

const toBg = (hex, alpha = ALPHA) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// 카드 헤더(진한 0.1 ≈ 디자인 #fdeeee)와 본문(연한 0.04)을 분리해 농도 차를 준다.
const make = (color) => ({
  color,
  bg: toBg(color),
  headerBg: toBg(color, 0.1),
  contentBg: toBg(color, 0.04),
});

export const NAMING_RULE_PALETTE = {
  용신: make('#e65555'),
  삼원오행: make('#74b75a'),
  조후: make('#4e80d6'),
  입묘: make('#f3ae11'),
  공망: make('#757575'),
  // 수리: Figma "그래프 바 색상" 노드에는 누락. HTML 프로토타입(naming_pages
  // /03_result_name_reco_hanja.html)의 --accent 색을 사용. 차후 Figma 확정 시 교체.
  수리: make('#6B5CE7'),
  원형이정: make('#8b6fd8'),
  음양수: make('#46b7c9'),
  업종적합: make('#d97c4a'),
  브랜드: make('#e06aa3'),
  '음운 조화': make('#5bbf95'),
  '한자 범주': make('#b08b57'),
  '음양 균형': make('#6078c9'),
  창의성: make('#9c5cf2'),
};

const FALLBACK = NAMING_RULE_PALETTE.공망;

/** 규칙 라벨로 팔레트 조회 — 미매칭 시 회색(공망) fallback */
export const getNamingRulePalette = (label) =>
  NAMING_RULE_PALETTE[label] || FALLBACK;
